// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GvQt","productName":"Table_productName__2jjMC"};